var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),(_vm.shouldShowConsent)?_c('CookieConsent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }